// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2Yp4c","approved":"Status_approved__3cb1K","rejected":"Status_rejected__2VqNF","expired":"Status_expired__1LzPd","label":"Status_label__24mNA"};